// src/App.tsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./features/auth/pages/LoginPage";
import AgreeTermsPage from "./features/auth/pages/AgreeTermsPage";
import RegisterPage from "./features/auth/pages/RegisterPage";
import BookSearchPage from "./features/books/pages/BookSearchPage";
import BookDetailPage from "./features/books/pages/BookDetailPage";
import LibraryPage from "./features/library/pages/LibraryPage";
import ReadingNotePage from "./features/readingnote/pages/ReadingNotePage";
import AllReviewsPage from "./features/readingnote/pages/AllReviewsPage";
import BookReviewNoteListPage from "./features/readingnote/pages/BookReadingNoteListPage";
import ReviewNoteComposePage from "./features/readingnote/pages/ReadingNoteComposePage";
import ReviewNoteEditPage from "./features/readingnote/pages/ReadingNoteEditPage";
import TalkToxListPage from "./features/tox/pages/TalkToxListPage";
import TalkToxDetailPage from "./features/tox/pages/TalkToxDetailPage";
import FindAccountPage from "./features/auth/pages/FindAccountPage";
import ResetPasswordPage from "./features/auth/pages/ResetPasswordPage";
import RequireLogin from "./features/auth/components/RequireLogin";
import MyPage from "./features/mypage/pages/MyPage";
import EditProfilePage from "./features/mypage/pages/EditProfilePage";
import NeedLoginPage from "./features/auth/pages/NeedLoginPage";


import { NotifyHost } from "./ui/NotifyHost";
import { ConfirmHost } from "./ui/ConfirmHost";

// --- Admin imports ---
import LegalTermsPage from "./features/legal/pages/LegalTermsPage";
import LegalPrivacyPage from "./features/legal/pages/LegalPrivacyPage";
import AdminLoginPage from "./features/admin/pages/AdminLoginPage";
import AdminGuard from "./features/admin/AdminGuard";
import AdminLayout from "./features/admin/AdminLayout";
import AdminUsersPage from "./features/admin/pages/AdminUsersPage";
import AdminToxListPage from "./features/admin/pages/AdminToxListPage";
import AdminToxEditPage from "./features/admin/pages/AdminToxEditPage";
import AdminAttendancePage from "./features/admin/pages/AdminAttendancePage";
import AdminBooksPage from "./features/admin/pages/AdminBooksPage";
import AdminKeywordsPage from "./features/admin/pages/AdminKeywordsPage";
import AdminBookStoresPage from "./features/admin/pages/AdminBookStoresPage";
import AdminUserStatsPage from "./features/admin/pages/AdminUserStatsPage";
import EventMainPage from "./features/event/pages/EventMainPage";
import EventAgreePage from "./features/event/pages/EventAgreePage";
import EventRegisterPage from "./features/event/pages/EventRegisterPage";
import EventLegalTermsPage from "./features/event/pages/EventLegalTermsPage";
import EventLegalPrivacyPage from "./features/event/pages/EventLegalPrivacyPage";

export default function App() {
    return (
        <>
        <NotifyHost />
        <ConfirmHost />
        <Routes>
            {/* 이벤트 */}
            <Route path="/event/main" element={<EventMainPage />} />
            <Route path="/event/agree" element={<EventAgreePage />} />
            <Route path="/event/register" element={<EventRegisterPage />} />
            <Route path="/event/legal/terms" element={<EventLegalTermsPage />} />
            <Route path="/event/legal/privacy" element={<EventLegalPrivacyPage />} />

            {/* 기존 사용자 플로우 */}
            <Route path="/" element={<Navigate to="/auth/login" replace />} />
            <Route path="/auth/login" element={<LoginPage />} />
            <Route path="/auth/agree" element={<AgreeTermsPage />} />
            <Route path="/auth/register" element={<RegisterPage />} />
            <Route path="/search" element={<BookSearchPage />} />
            <Route path="/books/:id" element={<RequireLogin featureName="상세 정보"><BookDetailPage /></RequireLogin>} />
            <Route path="/library" element={<RequireLogin featureName="서재"><LibraryPage /></RequireLogin>} />
            <Route path="/readingnote" element={<RequireLogin featureName="독서기록"><ReadingNotePage /></RequireLogin>} />
            <Route path="/review-feed" element={<AllReviewsPage />} />
            <Route path="/books/:bookId/reviews" element={<BookReviewNoteListPage />} />
            <Route path="/reviews/new" element={<ReviewNoteComposePage />} />
            <Route path="/reviews/:id/edit" element={<ReviewNoteEditPage />} />
            <Route path="/tox" element={<TalkToxListPage />} />
            <Route path="/tox/:id" element={<TalkToxDetailPage />} />
            <Route path="/auth/find" element={<FindAccountPage />} />
            <Route path="/auth/password-reset" element={<ResetPasswordPage />} />
            <Route path="/mypage" element={<RequireLogin><MyPage /></RequireLogin>} />
            <Route path="/mypage/edit" element={<RequireLogin><EditProfilePage /></RequireLogin>} />
            <Route path="/auth/need-login" element={<NeedLoginPage />} />

            {/* 법적 페이지 */}
            <Route path="/legal/terms" element={<LegalTermsPage />} />
            <Route path="/legal/privacy" element={<LegalPrivacyPage />} />

            {/* --- Admin --- */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminGuard />}>
                <Route element={<AdminLayout />}>
                    <Route index element={<Navigate to="tox" replace />} />
                    <Route path="users" element={<AdminUsersPage />} />
                    <Route path="tox" element={<AdminToxListPage />} />
                    <Route path="tox/new" element={<AdminToxEditPage />} />
                    <Route path="tox/:id" element={<AdminToxEditPage />} />
                    <Route path="attendance" element={<AdminAttendancePage />} />
                    <Route path="books-stats" element={<AdminBooksPage />} />
                    <Route path="keywords" element={<AdminKeywordsPage />} />
                    <Route path="book-stores" element={<AdminBookStoresPage />} />
                    <Route path="user-stats" element={<AdminUserStatsPage />} />
                </Route>
            </Route>

            <Route path="*" element={<Navigate to="/auth/login" replace />} />
        </Routes>
        </>
    );
}
